

import React from "react";
import { Link } from "react-router-dom";
import { ChevronLeft, ChevronRight } from "lucide-react";

interface PaginationProps {
  isPagination: boolean;
  data: any[];
  getState: () => {
    pagination: {
      pageSize: number;
      pageIndex: number;
    };
  };
  previousPage: () => void;
  nextPage: () => void;
  setPageIndex: (index: any) => void;
  getPageOptions: () => number[];
  getCanPreviousPage: () => boolean;
  getCanNextPage: () => boolean;
  PaginationClassName: string;
}
const Pagination: React.FC<PaginationProps> = ({
  isPagination,
  data,
  getState,
  previousPage,
  nextPage,
  setPageIndex,
  getPageOptions,
  getCanPreviousPage,
  getCanNextPage,
  PaginationClassName,
}) => {
  if (!isPagination) return null;

  const pageIndex = getState().pagination.pageIndex;
  const totalPages = getPageOptions().length;

  // نمایش صفحات 1 و 2 (در صورتی که حداقل دو صفحه وجود داشته باشد)
  const firstPages = totalPages > 1 ? [0, 1] : [0];

  // نمایش صفحات آخر (مثلاً 8، 9، 10 اگر 10 صفحه باشد)
  const lastPages = [totalPages - 3, totalPages - 2, totalPages - 1].filter(
    (p) => p >= 0
  );

  // نمایش 3 صفحه وسط
  const middlePages = [
    Math.max(0, pageIndex - 1),
    pageIndex,
    Math.min(totalPages - 1, pageIndex + 1),
  ];

  // ترکیب همه صفحات بدون تکرار
  const pagesToShow = Array.from(new Set([...firstPages, ...middlePages, ...lastPages]));

  // اگر فقط یک صفحه باشد، نیازی به نمایش صفحه دوم نیست
  if (totalPages === 1) {
    pagesToShow.splice(1); // حذف هر مقدار اضافی به جز صفحه اول
  }

  return (
    <div className={PaginationClassName}>
      <ul className="flex mt-4 flex-wrap items-center gap-2">
        {/* دکمه قبلی */}
        <li>
          <Link
            to="#!"
            className={`inline-flex items-center justify-center bg-white dark:bg-zinc-700 h-8 px-3 transition-all duration-150 ease-linear border rounded border-slate-200 dark:border-zinc-500 text-slate-500 dark:text-zinc-200 hover:text-custom-500 ${
              !getCanPreviousPage() && "disabled"
            }`}
            onClick={previousPage}
          >
            <ChevronLeft className="size-4 mr-1 rtl:rotate-180" /> قبلی
          </Link>
        </li>

        {/* نمایش صفحات */}
        {pagesToShow.map((item, index) => (
          <React.Fragment key={item}>
            {index > 0 && pagesToShow[index - 1] !== item - 1 && (
              <li className="text-slate-500 dark:text-zinc-200">...</li>
            )}
            <li>
              <Link
                to="#"
                className={`inline-flex items-center justify-center size-8 transition-all duration-150 ease-linear border rounded ${
                  pageIndex === item
                    ? "bg-custom-500 text-white dark:bg-custom-600"
                    : "bg-white text-slate-500 border-slate-200 dark:bg-zinc-700 dark:text-zinc-200"
                }`}
                onClick={(event) => {
                  event.preventDefault();
                  setPageIndex(item);
                }}
              >
                {item + 1}
              </Link>
            </li>
          </React.Fragment>
        ))}

        {/* دکمه بعدی */}
        <li>
          <Link
            to="#!"
            className={`inline-flex items-center justify-center bg-white dark:bg-zinc-700 h-8 px-3 transition-all duration-150 ease-linear border rounded border-slate-200 dark:border-zinc-500 text-slate-500 dark:text-zinc-200 hover:text-custom-500 ${
              pageIndex === totalPages - 1 || !getCanNextPage() ? "disabled" : ""
            }`}
            onClick={() => {
              if (getCanNextPage()) {
                nextPage();
              }
            }}
          >
            بعدی <ChevronRight className="size-4 ml-1 rtl:rotate-180" />
          </Link>
        </li>
      </ul>
      <div className="mt-2 text-slate-500 dark:text-zinc-200">
        صفحه {pageIndex + 1} از {totalPages}
      </div>
    </div>
  );
};




// const Pagination: React.FC<PaginationProps> = ({
//   isPagination,
//   data,
//   getState,
//   previousPage,
//   nextPage,
//   setPageIndex,
//   getPageOptions,
//   getCanPreviousPage,
//   getCanNextPage,
//   PaginationClassName,
// }) => {
//   if (!isPagination) return null;

//   const pageIndex = getState().pagination.pageIndex;
//   const totalPages = getPageOptions().length;
//   const maxPageNumbers = 5;
//   const startPage = Math.max(0, pageIndex - Math.floor(maxPageNumbers / 2));
//   const endPage = Math.min(totalPages, startPage + maxPageNumbers);

//   return (
//     <div className={PaginationClassName}>
//       <div className="mb-4 grow md:mb-2 mr-2 my-2">
//         <div className="text-slate-500 dark:text-zinc-200">
//           {/* <b className='mx-1'> {getState().pagination.pageSize}</b>
//           نمایش
//           از
//           <span className="font-bold mx-1">{data.length}</span>
//           <b> </b> نتیجه */}
//         </div>
//       </div>
//       <ul className="flex flex-wrap items-center gap-2 shrink-0">
//         <li>
//           <Link
//             to="#!"
//             className={`inline-flex items-center justify-center bg-white dark:bg-zinc-700 h-8 px-3 transition-all duration-150 ease-linear border rounded border-slate-200 dark:border-zinc-500 text-slate-500 dark:text-zinc-200 hover:text-custom-500 dark:hover:text-custom-500 hover:bg-custom-50 dark:hover:bg-custom-500/10 focus:bg-custom-50 dark:focus:bg-custom-500/10 focus:text-custom-500 dark:focus:text-custom-500 ${
//               !getCanPreviousPage() && "disabled"
//             }`}
//             onClick={previousPage}
//           >
//             <ChevronLeft className="size-4 mr-1 rtl:rotate-180" /> قبلی
//           </Link>
//         </li>
//         {getPageOptions()
//           .slice(startPage, endPage)
//           .map((item) => (
//             <li key={item}>
//               <Link
//                 to="#"
//                 className={`inline-flex items-center justify-center size-8 transition-all duration-150 ease-linear border rounded 
//           ${
//             pageIndex === item
//               ? "bg-custom-500 text-white dark:bg-custom-600 dark:text-white border-custom-500 dark:border-custom-600"
//               : "bg-white text-slate-500 border-slate-200 dark:bg-zinc-700 dark:text-zinc-200 dark:border-zinc-500 hover:text-custom-500 dark:hover:text-custom-500 hover:bg-custom-100 dark:hover:bg-custom-500/10 focus:bg-custom-50 dark:focus:bg-custom-500/10 focus:text-custom-500 dark:focus:text-custom-500"
//           }`}
//                 onClick={(event) => {
//                   event.preventDefault();
//                   setPageIndex(item);
//                 }}
//               >
//                 {item + 1}
//               </Link>
//             </li>
//           ))}

//         {/* {getPageOptions()
//           .slice(startPage, endPage)
//           .map((item, key) => (
//             <li key={key}>
//               <Link
//                 to="#"
//                 className={`inline-flex items-center justify-center size-8 transition-all duration-150 ease-linear border rounded 
//         ${
//           pageIndex === item
//             ? "bg-custom-500 text-white dark:bg-custom-600 dark:text-white border-custom-500 dark:border-custom-600"
//             : "bg-white text-slate-500 border-slate-200 dark:bg-zinc-700 dark:text-zinc-200 dark:border-zinc-500 hover:text-custom-500 dark:hover:text-custom-500 hover:bg-custom-100 dark:hover:bg-custom-500/10 focus:bg-custom-50 dark:focus:bg-custom-500/10 focus:text-custom-500 dark:focus:text-custom-500"
//         }`}
//                 onClick={() => setPageIndex(item)}
//               >
//                 {item + 1}
//               </Link>
//             </li>
//           ))} */}

//         {/* {getPageOptions()
//           .slice(startPage, endPage)
//           .map((item, key) => (
//             <React.Fragment key={key}>
//               <li>
//                 <Link
//                   to="#"
//                   className={`inline-flex items-center justify-center bg-white dark:bg-zinc-700 size-8 transition-all duration-150 ease-linear border rounded border-slate-200 dark:border-zinc-500 text-slate-500 dark:text-zinc-200 hover:text-custom-500 dark:hover:text-custom-500 hover:bg-custom-100 dark:hover:bg-custom-500/10 focus:bg-custom-50 dark:focus:bg-custom-500/10 focus:text-custom-500 dark:focus:text-custom-500 ${
//                     getState().pagination.pageIndex === item && "active"
//                   }`}
//                   onClick={() => setPageIndex(item)}
//                 >
//                   {item + 1}
//                 </Link>
//               </li>
//             </React.Fragment>
//           ))} */}
//         {totalPages > maxPageNumbers && pageIndex + 1 < totalPages && (
//           <li>
//             <span className="inline-flex items-center justify-center text-slate-500 dark:text-zinc-200">
//               ....
//               <span
//                 className="mr-1 inline-flex items-center justify-center bg-white dark:bg-zinc-700 size-8 transition-all duration-150 ease-linear border rounded border-slate-200 dark:border-zinc-500 text-slate-500 dark:text-zinc-200 hover:text-custom-500 dark:hover:text-custom-500 hover:bg-custom-100 dark:hover:bg-custom-500/10 focus:bg-custom-50 dark:focus:bg-custom-500/10 focus:text-custom-500 dark:focus:text-custom-500 cursor-pointer"
//                 onClick={() => setPageIndex(totalPages - 1)} // اضافه شدن این بخش
//               >
//                 {totalPages}
//               </span>
//             </span>
//           </li>
//         )}
//         <li>
//           <Link
//             to="#!"
//             className={`inline-flex items-center justify-center bg-white dark:bg-zinc-700 h-8 px-3 transition-all duration-150 ease-linear border rounded border-slate-200 dark:border-zinc-500 text-slate-500 dark:text-zinc-200 hover:text-custom-500 dark:hover:text-custom-500 hover:bg-custom-50 dark:hover:bg-custom-500/10 focus:bg-custom-50 dark:focus:bg-custom-500/10 focus:text-custom-500 dark:focus:text-custom-500 ${
//               !getCanNextPage() && "disabled"
//             }`}
//             onClick={() => getCanNextPage() && nextPage()}
//           >
//             بعدی <ChevronRight className="size-4 ml-1 rtl:rotate-180" />
//           </Link>
//         </li>
//       </ul>
//       <div className="mt-2 text-slate-500 dark:text-zinc-200">
//         صفحه {pageIndex + 1} از {totalPages}
//       </div>
//     </div>
//   );
// };

export default Pagination;
